import React from 'react';
import { Row, Col } from 'react-bootstrap';
import PropTypes from 'prop-types';
import { getDisplayType } from '../../../utils/helpers';
import useWindowWidth from '../../../hooks/useWindowWidth';
import { TEXT_CONSTANT, IMAGE_CONSTANT } from '../../../constants/app';
import Button from '../../../ui-core/Button/Button';
import './style.css';

const benefits = [
  {
    title: 'Daily Brand New Videos',
    description:
      '14 videos that are about 10 minutes long and assess something different in the foot-ankle complex that include exercises to help each particular restriction each day.',
    src: IMAGE_CONSTANT.dailyVideosIcon,
  },
  {
    title: 'Guided Workbook',
    description:
      'This mini-course comes with a guided workbook with pages for each day for you to take notes and jot down additional findings during and after each video.',
    src: IMAGE_CONSTANT.workbookIcon,
  },
  {
    title: 'Calendar',
    description:
      'We love something to follow! Our platform will automatically check off your progress as you complete each day. Our calendar allows you to automatically keep track of your progress',
    src: IMAGE_CONSTANT.calendarIcon,
  },
  {
    title: 'Interview with Functional Podiatrist',
    description:
      'Dr. Emily Splichal presented an incredibly useful and insightful interview, answering real questions, providing specific shoe brand recommendations and educating on diagnoses.',
    src: IMAGE_CONSTANT.liveRecordedInterviewIcon,
  },
];

const Benefits = props => {
  const isDesktopScreen = getDisplayType(useWindowWidth()) === 'desktop';
  const handleClick = () => {
    if (props.onClick) {
      props.onClick(
        TEXT_CONSTANT.JOIN_THE_COURSE,
        'isSignup',
        TEXT_CONSTANT.BARE_FOOT_COURSE,
      );
    }
  };
  return (
    <div className="course-benefits">
      <div className="container">
        <h4>{TEXT_CONSTANT.BARE_FOOT_COURSE}</h4>
        <Row>
          {benefits.map((benefit, index) => (
            <Col key={`benefit-${index + 1}`} sm={isDesktopScreen ? 6 : 12}>
              <div className="course-benefits-card">
                <img
                  src={benefit.src}
                  alt={benefit.title}
                  className="img-fluid"
                />
                <div className="d-flex flex-column">
                  <h5>{benefit.title}</h5>
                  <p>{benefit.description}</p>
                </div>
              </div>
            </Col>
          ))}
        </Row>
        <h5>{TEXT_CONSTANT.READY_TO_LEARN}</h5>
        <Button
          onClick={handleClick}
          text={props.btnText}
          class="sign-up-button-new d-inline-block mx-auto mb-3 text-uppercase"
        />
      </div>
    </div>
  );
};

Benefits.propTypes = {
  btnText: PropTypes.string,
  onClick: PropTypes.func,
};

Benefits.defaultProps = {
  btnText: TEXT_CONSTANT.JOIN_THE_COURSE,
};

export default Benefits;
